import { render, staticRenderFns } from "./additional-load-cell.vue?vue&type=template&id=2c68fa66&scoped=true&"
import script from "./additional-load-cell.vue?vue&type=script&lang=js&"
export * from "./additional-load-cell.vue?vue&type=script&lang=js&"
import style0 from "./additional-load-cell.vue?vue&type=style&index=0&id=2c68fa66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c68fa66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c68fa66')) {
      api.createRecord('2c68fa66', component.options)
    } else {
      api.reload('2c68fa66', component.options)
    }
    module.hot.accept("./additional-load-cell.vue?vue&type=template&id=2c68fa66&scoped=true&", function () {
      api.rerender('2c68fa66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/additions/additional-load-cell.vue"
export default component.exports